import { render, staticRenderFns } from "./xuanzeyisheng.vue?vue&type=template&id=1d6926b6&scoped=true"
import script from "./xuanzeyisheng.vue?vue&type=script&lang=js"
export * from "./xuanzeyisheng.vue?vue&type=script&lang=js"
import style0 from "./xuanzeyisheng.vue?vue&type=style&index=0&id=1d6926b6&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6926b6",
  null
  
)

export default component.exports